import { sortBy } from 'lodash';
import Table from 'components/UIKit/Table';
import ErrorSummaryColumns from './ErrorSummaryColumns';
import ErrorSummaryRows from './ErrorSummaryRows';

type ErrorSummaryTableProps = {
  router: Object,
  sort: string,
  order: string,
  children: any
}

export default function ErrorSummaryTable({
  children,
  router,
  sort,
  order,
}: ErrorSummaryTableProps): React.Element {
  const list = sortBy(children, [sort]);

  return (
    <Table>
      <ErrorSummaryColumns sort={sort} order={order} />
      <ErrorSummaryRows router={router}>
        {// silly logic since we're ordering alphabetically
          order === 'desc'
          ? list.concat().reverse()
          : list
        }
      </ErrorSummaryRows>
    </Table>
  );
}
